import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const RecruitmentFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [recruitmentCampaign, setRecruitmentCampaign] = useState([]);
  const [partner, setPartner] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().recruitmentId) || (entity === 'recruitment' && id)) {
      apiCall('patch', '/api/v2/recruitment/' + (window.App.urlVars().recruitmentId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderRecruitmentList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/recruitment', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderRecruitmentList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/recruitment/recruitment/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/recruitment-campaign', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
      setRecruitmentCampaign(response.data.data.items || [])
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    })
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/partner', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
      setPartner(response.data.data.items || [])
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    })
  }, [])

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().recruitmentId) || (entity === 'recruitment' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/recruitment/' + (window.App.urlVars().recruitmentId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"recruitment-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-6"}>
              <Field name="recruitmentCampaign" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="recruitmentCampaign">{props.t('fieldRecruitmentCampaign')}</label>

                  <Dropdown
                    id="recruitmentCampaign"
                    value={
                      formData.recruitment_campaign?.id ||
                      formData.recruitmentCampaign ||
                      formData.recruitment_campaign ||
                      null
                    }
                    options={window.App.sortDropdownOptions(recruitmentCampaign, "name")}
                    optionLabel="name"
                    optionValue="id"
                    placeholder={t('selectPlaceholder')}
                    appendTo={document.body}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        recruitmentCampaign: e.value,
                        recruitment_campaign: e.value
                      });

                      setNewFormData({
                        ...newFormData,
                        recruitmentCampaign: e.value
                      });
                    }}
                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                  />

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="partner" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="partner">{props.t('fieldPartners')}</label>

                  <Dropdown
                    id="partner"
                    value={
                      formData.partner?.id ||
                      formData.partner ||
                      null
                    }
                    options={window.App.sortDropdownOptions(partner, "name")}
                    optionLabel="name"
                    optionValue="id"
                    placeholder={t('selectPlaceholder')}
                    appendTo={document.body}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        partner: e.value
                      });

                      setNewFormData({
                        ...newFormData,
                        partner: e.value
                      });
                    }}
                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                  />

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-6"}>
              <Field name="owner" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="owner">{props.t('fieldOwner')}</label>

                  <Dropdown
                    id="owner"
                    value={
                      formData.owner?.id ||
                      formData.owner ||
                      null
                    }
                    options={window.App.sortDropdownOptions(partner, "name")}
                    optionLabel="name"
                    optionValue="id"
                    placeholder={t('selectPlaceholder')}
                    appendTo={document.body}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        owner: e.value
                      });

                      setNewFormData({
                        ...newFormData,
                        owner: e.value
                      });
                    }}
                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                  />

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'recruitment' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(RecruitmentFormComponent);
